var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsCameraFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zfh0wss2ja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1368 0v1600H0V0h1368z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p09f8aebxb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.333 0a5.333 5.333 0 0 1 5.334 5.333v8L56.594 4.05a1.333 1.333 0 0 1 2.073 1.109v32.35a1.333 1.333 0 0 1-2.073 1.11l-13.927-9.285v8a5.333 5.333 0 0 1-5.334 5.334h-32A5.333 5.333 0 0 1 0 37.333v-32A5.333 5.333 0 0 1 5.333 0h32z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zfh0wss2ja)",
    transform: "translate(-208 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p09f8aebxb)",
    transform: "translate(210.667 346.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h58.667v42.667H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCameraFilled);
export default __webpack_public_path__ + "static/media/icons-camera-filled.6f58a1bbe649e76320e31089aa9297d4.svg";
export { ForwardRef as ReactComponent };